import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';

export const useDeleteLocalRateGroupsMutation = () =>
    useRepositoryMutation('rateGroups', 'delete', {
        invalidateQueries: {
            portfolioCentralRateGroups: ['getOverview'],
            portfolioRateGroups: ['getOverview'],
        },
    });

export const useEditLocalRateGroup = () =>
    useRepositoryMutation('rateGroups', 'update', {
        invalidateQueries: { portfolioRateGroups: ['getOverview'], rateGroups: ['getAll'] },
        onSuccess: () => {
            showSuccessAlert({
                title: lt('ChangesSuccessfullySaved'),
            });
        },
    });
